import * as THREE from 'three'

export default class Actor extends THREE.Object3D {

    constructor(){
        super();
    }


    beginPlay(){

    }

    tick(){

    }
}